/* eslint-disable no-param-reassign */
import _ from 'lodash';
import oax from '../utils/oax';

export default {
  data() {
    return {
      oax,
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    },
    langType() {
      return this.lang === 'kr' ? 'ko' : 'en';
    },
    handler() {
      return sub => (error) => {
        if (!error) return;
        let errData;
        if (error.response) {
          if (error.response.data) {
            errData = error.response.data;
          }
        }
        if (error.data) {
          errData = error.data;
        }
        if (!errData) {
          console.error(error);
          return;
        }
        if (errData.code) {
          if (sub && sub(errData)) return;
        }
        window.alert(errData.message || errData);
      };
    },
    sect() {
      return this.$store.state.sect;
    },
    sv() {
      return this.$store.state.sv;
    },
    onFix() {
      return this.$store.state.onFix;
    },
    popupVideo() {
      return this.$store.state.popupVideo;
    },
    kr() {
      return this.$store.state.lang === 'kr';
    },
    sdir() {
      return this.$store.state.sdir;
    },
    freeze() {
      return this.$store.state.chuncheonPopup || this.$store.state.nav;
    },
    videoBase() {
      return this.$store.state.videoBase;
    },
  },
  methods: {
    values(...args) {
      return _.reduce(args, (acc, v) => { acc[v] = true; return acc; }, {});
    },
    shapeContent(cont) {
      if (!cont) return '';
      return cont.replace(/[\r\n]\s*[\r\n]/g, '<br><br>');
    },
    trim(v) {
      return _.trim(v);
    },
    splitYmd(ymd, split) {
      if (!ymd) return '';
      split = split || '-';
      return ymd.replace(/(\d{4})(\d{2})(\d{2})/,`$1${split}$2${split}$3`);
    },
  }
};
